import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { ASSETS, CONTACT } from "../lib/constants";

const ease = [0.76, 0, 0.24, 1];

export default function Mentor() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [80, -80]);

  return (
    <section
      id="mentor"
      ref={ref}
      data-testid="mentor-section"
      className="relative py-24 md:py-32 lg:py-40 bg-cream-dim overflow-hidden border-t border-ink-15"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 lg:px-16 relative">
        <div className="grid grid-cols-12 gap-6 md:gap-14 items-start">
          <div className="col-span-12 lg:col-span-8 order-2 lg:order-1">
            <motion.h2
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, ease }}
              className="font-display font-light text-5xl md:text-7xl lg:text-8xl leading-[0.92] tracking-[-0.03em] text-ink"
              style={{ fontVariationSettings: '"SOFT" 40' }}
            >
              Meet Himanshu <br />
              <span className="italic font-light">Bhansali</span> Sir
            </motion.h2>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, delay: 0.15, ease }}
              className="mt-10 space-y-6 max-w-2xl"
            >
              <p className="text-lg md:text-xl leading-[1.75] text-ink/85 font-light">
                Founder of NavSankalpIAS. Over seven years of guiding UPSC Civil Services aspirants through the entirety of their preparation — from foundation to final interview. Formerly with <span className="italic">VisionIAS</span> (4+ years), Success Point Academy and other national institutions.
              </p>
              <p className="text-lg leading-[1.75] text-ink/75 font-light">
                His approach refuses the impersonal batch model. Every aspirant receives a plan calibrated to their background, weekly accountability, and honest feedback on answer writing — the three things that quietly separate a rank from a repeat attempt.
              </p>

              <div className="pt-8 border-t border-ink/15 grid grid-cols-2 md:grid-cols-4 gap-6">
                {[
                  { k: "07+", v: "Years' Experience" },
                  { k: "04+", v: "Years at VisionIAS" },
                  { k: "1000+", v: "Aspirants Mentored" },
                  { k: "2000+", v: "Mains Copies Evaluated" },
                ].map((s) => (
                  <div key={s.v}>
                    <div
                      className="font-display italic font-light text-3xl md:text-4xl text-saffron"
                      style={{ fontVariationSettings: '"SOFT" 100' }}
                    >
                      {s.k}
                    </div>
                    <div className="text-[10px] tracking-[0.28em] uppercase text-ink/55 mt-2 font-medium">{s.v}</div>
                  </div>
                ))}
              </div>

              <div className="pt-8 flex flex-wrap gap-4">
                <a
                  href={CONTACT.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="mentor-whatsapp-btn"
                  className="mag-btn cream bg-ink text-cream hover:text-ink px-8 py-4 text-xs tracking-[0.22em] uppercase font-semibold border border-ink"
                >
                  Message the Mentor
                </a>
              </div>
            </motion.div>
          </div>

          <motion.div style={{ y }} className="col-span-12 lg:col-span-4 order-1 lg:order-2">
            <motion.div
              initial={{ opacity: 0, scale: 1.05 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.1, ease }}
              className="relative"
            >
              <div className="frame-mount">
                <img
                  src={ASSETS.portrait}
                  alt="Himanshu Bhansali Sir"
                  className="w-full h-auto object-cover"
                  style={{ aspectRatio: "3/4" }}
                  data-testid="mentor-portrait"
                />
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
